import {
  ADD_ORGANIZATION,
  ADD_ORGANIZATION_SUCCESS,
  ADD_ORGANIZATION_FAILURE,
  UPDATE_ORGANIZATION,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_FAILURE,
  DELETE_ORGANIZATION,
  DELETE_ORGANIZATION_SUCCESS,
  DELETE_ORGANIZATION_FAILURE,
  GET_ORGANIZATIONS,
  GET_ORGANIZATIONS_SUCCESS,
  GET_ORGANIZATIONS_FAILURE,
  GET_PRE_ON_BOARDED_ORGANIZATIONS,
  GET_PRE_ON_BOARDED_ORGANIZATIONS_SUCCESS,
  GET_PRE_ON_BOARDED_ORGANIZATIONS_FAILURE,  
  RESEND_ORG_ON_BOARD_ACTIVATION_LINK,
  RESEND_ORG_ON_BOARD_ACTIVATION_LINK_SUCCESS,
  RESEND_ORG_ON_BOARD_ACTIVATION_LINK_FAILURE,  
  REGISTER_TRIAL_ACCOUNT_USER,
  REGISTER_TRIAL_ACCOUNT_USER_SUCCESS,
  REGISTER_TRIAL_ACCOUNT_USER_FAILURE,
  CLEAR_ALL_MESSAGES_SUCCESS,
  CLEAR_SUCCESS_MESSAGES_SUCCESS,
  CLEAR_FAILURE_MESSAGES_SUCCESS,
} from "./actionTypes";

const initialState = {
  addOrganizationError: null,
  isAddingOrganization: false,
  addOrganizationMessage: null,

  updateOrganizationError: null,
  isUpdatingOrganization: false,
  updateOrganizationMessage: null,

  deleteOrganizationError: null,
  isDeletingOrganization: false,
  deleteOrganizationMessage: null,

  getOrganizationsError: null,
  isGettingOrganizations: false,
  getOrganizationsMessage: null,

  getPreOnBoardedOrganizationsError: null,
  isGettingPreOnBoardedOrganizations: false,
  getPreOnBoardedOrganizationsMessage: null,

  resendOrgOnBoardActivationLinkError: null,
  isResendingOrgOnBoardActivationLink: false,
  resendOrgOnBoardActivationLinkMessage: null,

  registerTrialAccountUserError: null,
  isRegisteringTrialAccountUser: false,
  registerTrialAccountUserMessage: null,
};

const organization = (state = initialState, action) => {
  console.log("reducer, action Type :: ", action.type);
  switch (action.type) {
    case ADD_ORGANIZATION:
      console.log(
        "reducer -> ADD_ORGANIZATION called with organization: ",
        action.payload.organization
      );
      state = {
        ...state,
        isAddingOrganization: true,
        addOrganizationError: null,
        organization: action.payload.organization,
        addOrganizationMessage: null,
      };
      break;
    case ADD_ORGANIZATION_SUCCESS:
      console.log(
        "reducer -> ADD_ORGANIZATION_SUCCESS called with organization: ",
        action.payload.organization
      );
      state = {
        ...state,
        isAddingOrganization: false,
        addOrganizationError: null,
        organization: action.payload.organization,
        addOrganizationMessage: "Organization added successfully!",
      };
      break;
    case ADD_ORGANIZATION_FAILURE:
      console.log(
        "reducer -> ADD_ORGANIZATION_FAILURE called with error: ",
        action.payload.error
      );
      state = {
        ...state,
        isAddingOrganization: false,
        addOrganizationError: action.payload.error,
        organization: null,
      };
      break;
    case UPDATE_ORGANIZATION:
      console.log(
        "reducer -> UPDATE_ORGANIZATION called with organization: ",
        action.payload.organization
      );
      state = {
        ...state,
        isUpdatingOrganization: true,
        updateOrganizationError: null,
        organization: action.payload.organization,
        updateOrganizationMessage: null,
      };
      break;
    case UPDATE_ORGANIZATION_SUCCESS:
      console.log(
        "reducer -> UPDATE_ORGANIZATION_SUCCESS called"
      );
      state = {
        ...state,
        isUpdatingOrganization: false,
        updateOrganizationError: null,
        updateOrganizationMessage: "Organization Updated successfully!",
      };
      break;
    case UPDATE_ORGANIZATION_FAILURE:
      console.log(
        "reducer -> UPDATE_ORGANIZATION_FAILURE called with error: ",
        action.payload.error
      );
      state = {
        ...state,
        isUpdatingOrganization: false,
        updateOrganizationError: action.payload.error,
        organization: null,
      };
      break;
    case DELETE_ORGANIZATION:
      console.log(
        "reducer -> DELETE_ORGANIZATION called with organization code: ",
        action.payload.orgCode
      );
      state = {
        ...state,
        isDeletingOrganization: true,
        deleteOrganizationError: null,
        orgCode: action.payload.orgCode,
        deleteOrganizationMessage: null,
      };
      break;
    case DELETE_ORGANIZATION_SUCCESS:
      console.log(
        "reducer -> DELETE_ORGANIZATION_SUCCESS called");
      state = {
        ...state,
        isDeletingOrganization: false,
        deleteOrganizationError: null,
        deleteOrganizationMessage: "Organization Deleted successfully!",
      };
      break;
    case DELETE_ORGANIZATION_FAILURE:
      console.log(
        "reducer -> DELETE_ORGANIZATION_FAILURE called with error: ",
        action.payload.error
      );
      state = {
        ...state,
        isDeletingOrganization: false,
        deleteOrganizationError: action.payload.error,
        orgCode: null,
      };
      break;
    case GET_ORGANIZATIONS:
      console.log("reducer -> GET_ORGANIZATIONS called ");
      state = {
        ...state,
        isGettingOrganizations: true,
        getOrganizationsError: null,
        //TODO: change organizations
        organizations: null,
        getOrganizationsMessage: null,
      };
      break;
    case GET_ORGANIZATIONS_SUCCESS:
      console.log(
        "reducer -> GET_ORGANIZATIONS_SUCCESS called with Organizations :: ",
        action.payload.organizations
      );
      state = {
        ...state,
        isGettingOrganizations: false,
        getOrganizationsError: null,
        organizations: action.payload.organizations,
        getOrganizationsMessage: "Organizations retrieved successfully!",
      };
      break;
    case GET_ORGANIZATIONS_FAILURE:
      console.log(
        "reducer -> GET_ORGANIZATIONS_FAILURE called with error :: ",
        action.payload.error
      );
      state = {
        ...state,
        isGettingOrganizations: false,
        getOrganizationsError: action.payload.error,
        organizations: null,
      };
      break;
    case GET_PRE_ON_BOARDED_ORGANIZATIONS:
      console.log("reducer -> GET_PRE_ON_BOARDED_ORGANIZATIONS called ");
      state = {
        ...state,
        isGettingPreOnBoardedOrganizations: true,
        getPreOnBoardedOrganizationsError: null,
        preOnBoardedOrganizations: null,
        getPreOnBoardedOrganizationsMessage: null,
      };
      break;
    case GET_PRE_ON_BOARDED_ORGANIZATIONS_SUCCESS:
      console.log(
        "reducer -> GET_PRE_ON_BOARDED_ORGANIZATIONS_SUCCESS called with Organizations :: ",
        action.payload.getPreOnBoardedOrganizationsSuccessMessage
      );
      state = {
        ...state,
        isGettingPreOnBoardedOrganizations: false,
        getPreOnBoardedOrganizationsError: null,
        preOnBoardedOrganizations: action.payload.preOnBoardedOrganizations,
        getPreOnBoardedOrganizationsMessage: "Pre on boarded organizations retrieved successfully!",
      };
      break;
    case GET_PRE_ON_BOARDED_ORGANIZATIONS_FAILURE:
      console.log(
        "reducer -> GET_PRE_ON_BOARDED_ORGANIZATIONS_FAILURE called with error :: ",
        action.payload.getPreOnBoardedOrganizationsError
      );
      state = {
        ...state,
        isGettingPreOnBoardedOrganizations: false,
        getPreOnBoardedOrganizationsError: action.payload.getPreOnBoardedOrganizationsError,
        preOnBoardedOrganizations: null,
      };
      break;
    case RESEND_ORG_ON_BOARD_ACTIVATION_LINK:
      console.log("reducer -> RESEND_ORG_ON_BOARD_ACTIVATION_LINK called ");
      state = {
        ...state,
        isResendingOrgOnBoardActivationLink: true,
        resendOrgOnBoardActivationLinkError: null,
        resendOrgOnBoardActivationLinkMessage: null,
      };
      break;
    case RESEND_ORG_ON_BOARD_ACTIVATION_LINK_SUCCESS:
      console.log("reducer -> RESEND_ORG_ON_BOARD_ACTIVATION_LINK_SUCCESS called ");
      state = {
        ...state,
        isResendingOrgOnBoardActivationLink: false,
        resendOrgOnBoardActivationLinkMessage: action.payload.resendOrgOnBoardActionLinkMessage,
      };
      break;
    case RESEND_ORG_ON_BOARD_ACTIVATION_LINK_FAILURE:
      console.log("reducer -> RESEND_ORG_ON_BOARD_ACTIVATION_LINK_FAILURE called ");
      state = {
        ...state,
        isResendingOrgOnBoardActivationLink: false,
        resendOrgOnBoardActivationLinkError: action.payload.resendOrgOnBoardActionLinkError,
      };
      break;      
    case REGISTER_TRIAL_ACCOUNT_USER:
      console.log(
        "reducer -> REGISTER_TRIAL_ACCOUNT_USER called with user: ",
        action.payload.user
      );
      state = {
        ...state,
        isRegisteringTrialAccountUser: true,
        registerTrialAccountUserError: null,
        user: action.payload.user,
        registerTrialAccountUserMessage: null,
      };
      break;
    case REGISTER_TRIAL_ACCOUNT_USER_SUCCESS:
      console.log(
        "reducer -> REGISTER_TRIAL_ACCOUNT_USER_SUCCESS called with user: ",
        action.payload.user
      );
      state = {
        ...state,
        isRegisteringTrialAccountUser: false,
        registerTrialAccountUserError: null,
        user: action.payload.user,
        registerTrialAccountUserMessage: action.payload.user,
      };
      break;
    case REGISTER_TRIAL_ACCOUNT_USER_FAILURE:
      console.log(
        "reducer -> REGISTER_TRIAL_ACCOUNT_USER_FAILURE called with error: ",
        action.payload.error
      );
      state = {
        ...state,
        isRegisteringTrialAccountUser: false,
        registerTrialAccountUserError: action.payload.error,
        user: null,
      };
      break;

    case CLEAR_ALL_MESSAGES_SUCCESS:
      state = {
        ...state,
        addOrganizationMessage: null,
        getOrganizationsMessage: null,
        getPreOnBoardedOrganizationsMessage: null,
        resendOrgOnBoardActivationLinkMessage: null,
        registerTrialAccountUserMessage: null,
        updateOrganizationMessage: null,
        deleteOrganizationMessage: null,

        addOrganizationError: null,
        getOrganizationsError: null,
        getPreOnBoardedOrganizationsError: null,
        resendOrgOnBoardActivationLinkError: null,
        registerTrialAccountUserError: null,
        updateOrganizationError: null,
        deleteOrganizationError: null,
      };
      break;
    case CLEAR_SUCCESS_MESSAGES_SUCCESS:
      state = {
        ...state,
        addOrganizationMessage: null,
        getOrganizationsMessage: null,
        getPreOnBoardedOrganizationsMessage: null,
        resendOrgOnBoardActivationLinkMessage: null,
        registerTrialAccountUserMessage: null,
        updateOrganizationMessage: null,
        deleteOrganizationMessage: null,
      };
      break;
    case CLEAR_FAILURE_MESSAGES_SUCCESS:
      state = {
        ...state,
        addOrganizationError: null,
        getOrganizationsError: null,
        getPreOnBoardedOrganizationsError: null,
        resendOrgOnBoardActivationLinkError: null,
        registerTrialAccountUserError: null,
        updateOrganizationError: null,
        deleteOrganizationError: null,
      };
      break;
    default:
      return state;
  }
  return state;
}

export default organization;